import React, { useState } from 'react';
import { motion } from 'framer-motion';
function Gallery({ language }) {
  const [imageErrors, setImageErrors] = useState({});
  const images = Array.from({ length: 22 }, (_, i) => `/img/${i + 1}.jpeg`);

  const handleImageError = (index) => {
    setImageErrors(prev => ({ ...prev, [index]: true }));
  };

  return (
    <div style={{ marginTop: '80px' }}>
      <motion.section 
        className="hero" 
        style={{ height: '50vh' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >
        <div className="hero-content">
          <h1 className="page-hero-title">फोटो गॅलरी</h1>
          <p className="page-hero-sub">आमच्या गावातील सुंदर क्षण</p>
        </div>
      </motion.section>

      <section className="services-section">
        <h2 className="section-title">गाव फोटो गॅलरी</h2>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
          gap: '2rem' 
        }}>
          {images.map((img, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.05 }}
              whileHover={{ scale: 1.05 }}
              style={{
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                height: '250px',
                background: '#f0f0f0'
              }}
            >
              {!imageErrors[index] ? (
                <img 
                  src={img} 
                  alt={`Gallery ${index + 1}`} 
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  onError={() => handleImageError(index)}
                />
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: '600'
                }}>
                  छायाचित्र {index + 1}
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Gallery;
